import { useEffect, useState } from 'react';

export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 1024 && window.innerWidth > 768);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const getSelectStyles = () => ({
    control: (provided: any) => ({
      ...provided,
      minHeight: isMobile ? '44px' : '40px',
      fontSize: isMobile ? '16px' : '14px', // Prevent zoom on iOS
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: isMobile ? '8px 12px' : '2px 8px',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: isMobile ? '44px' : '40px',
    }),
  });
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      const tablet = window.innerWidth <= 1024 && window.innerWidth > 768;
      setIsMobile(mobile);
      setIsTablet(tablet);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Close sidebar when clicking outside on mobile
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const sidebar = document.querySelector('.sideBarContainer');
      const toggle = document.querySelector('.mobile-menu-toggle');

      if (isMobile && sidebarOpen &&
        sidebar && !sidebar.contains(event.target as Node) &&
        toggle && !toggle.contains(event.target as Node)) {
        setSidebarOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isMobile, sidebarOpen]);
  return {
    isMobile,
    isTablet,
    sidebarOpen,
    setSidebarOpen,
    getSelectStyles
  }
}